<template>
  <!-- plots-->
  <div v-if="parceled" class="white-bg rounded tariff-item p2 no-box">
    <div class="col-12 flex flex-wrap no-box items-center pb1">
      <span class="h5 bold flex-auto">Mes prochains paiements:</span>
    </div>
    <div v-for="(plot, index) in plots" :key="index" class="col-12 no-box pl2">
      <div class="col-12 flex no-box pr1">
        <div class="inline-block flex flex-auto items-center">
          <span class="h5 bold "> Date: {{ plot.date }}</span>
        </div>
        <span class="h6 bold right">{{ plot.value }} €</span>
      </div>
    </div>
  </div>
</template>

<script>
import { format, addMonths, addDays } from 'date-fns';

export default {
  props: { parceled: Boolean },
  data () {
    return {
      cart: this.$store.state.cart,
      workspace: this.$store.getters.workspace
    };
  },
  computed: {
    order () {
      return this.$store.state.order;
    },
    priceInfo () {
      return this.cart.items.find(item => item.workspace === this.workspace).priceInfo;
    },
    plots () {
      const { priceInfo } = this;

      if (priceInfo) {
        const plots = [];
        const parcels = this.order.order.installment || 4;

        const { totalPrice } = this.priceInfo;
        const firstPayment = this.order.order.payments.length ? this.order.order.payments[0].amount / 100 : totalPrice / parcels;
        const othersPayments = (totalPrice - firstPayment) / (parcels - 1);

        for (let i = 1; i < parcels; i += 1) {
          plots.push({
            value: othersPayments,
            date: format(process.env.VUE_APP_ENVIRONMENT === 'staging' ? addDays(new Date(), i) : addMonths(new Date(), i), 'dd/MM/yyyy')
          });
        }
        return plots;
      }
      return [];
    }
  }
};
</script>
